import * as axiosBase from '@/api/index.js';

// 绑定、解绑设备
export let bind = function(params) {
  return axiosBase.POST("/yitiji/bind/bind", params)
}

// 查询绑定设备
export let bindQuery = function(params) {
  return axiosBase.GET("/yitiji/bind/query", params)
}

// 查询首页记录
export let queryLatest = function(params) {
  return axiosBase.GET("/yitiji/data/queryLatest", params)
}

// 周/月/年详细数据查询(分页查询)
export let detail = function(url, params) {
  return axiosBase.GET(url, params)
}

// 周/月/年汇总统计
export let summary = function(url, params) {
  return axiosBase.GET(url, params)
}

// 周/月/年异常详情数据查询(分页查询)
export let abnormal = function(url, params) {
  return axiosBase.GET(url, params)
}

// 获取有数据的日期
export let queryDate = function(params) {
  return axiosBase.GET("/yitiji/data/queryDate", params)
}



// WEBPACK FOOTER //
// ./src/api/machine/machine.js